import {
  BaseStepActions,
  BaseStepsActionTypes,
} from '@ordersnproducts/modules/new-repeat-order/actions/base-stepper-actions';

// tslint:disable-next-line:no-empty-interface
export interface RepeatOrderState {
  activeStep: number;
  disableNavigation: boolean;
  external: boolean;
  orderFromStore: boolean;
}

export const initialState: RepeatOrderState = {
  activeStep: null,
  disableNavigation: true,
  external: false,
  orderFromStore: false,
};

export function reducer(state = initialState, action: BaseStepActions): RepeatOrderState {
  switch (action.type) {
    case BaseStepsActionTypes.SET_ACTIVE_STEP: {
      return {
        ...state,
        activeStep: action.payload,
      };
    }
    case BaseStepsActionTypes.DISABLE_NAVIGATION: {
      return {
        ...state,
        disableNavigation: action.payload,
      };
    }
    case BaseStepsActionTypes.EXTERNAL_LOAD: {
      return {
        ...state,
        external: action.payload,
      };
    }
    case BaseStepsActionTypes.ORDER_FROM_STORE: {
      return {
        ...state,
        orderFromStore: action.payload,
      };
    }
    case BaseStepsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
